<div class="content">
  <div id="confirm-container">
    <div id="confirm-text-container">
      <h6>{{ "flight.result-flight.almost-there" | translate }}</h6>
      <form id="extraInfo" [formGroup]="extraInfoForm" *ngIf="extraInfoForm != null">
        <div class="input-row">
          <div>
            <p class="semi-bold" style="padding-right: 1rem;">
              {{ "common.custom-code" | translate }}
            </p>
            <label class="border-radius-20" style="width: 100%; padding-right: 1rem;">
              <input id="customCode" type="text" formControlName="customCode" placeholder="(PPT...)"
                class="form-control form-control--no-border" />
            </label>
          </div>
          <div>
            <p class="semi-bold" style="padding-left: 1rem;">
              {{ "common.cost-center" | translate }}
            </p>
            <label class="border-radius-20" style="width: 100%; padding-left: 1rem;">
              <input id="costCenter" type="text" formControlName="costCenter"
                class="form-control form-control--no-border" />
            </label>
          </div>
        </div>
        <div class="row">
          <div class="input-full-row" *ngIf="(trainsInfo?.userFilters.onlyTrainAuthorization && !isAdmin)">
            <label class="border-radius-20">
              <textarea id="travellerReason" formControlName="travellerReason"
                placeholder="{{ 'authorization.comment-reason' | translate }}"
                class="form-control form-control--no-border" rows="3"></textarea>
            </label>
          </div>
          <div class="input-full-row">
            <p class="semi-bold">
              {{ "flight.form-flight.annotations" | translate }}
            </p>
            <label class="border-radius-20">
              <textarea id="annotationsExtras" formControlName="annotationsExtras"
                placeholder="{{ 'train.form-train.extras-annotations' | translate }}"
                class="form-control form-control--no-border" rows="4"></textarea>
            </label>
          </div>
        </div>
      </form>
    </div>

    <div>
      <div>
        <p style="font-size: 10px; font-weight: 300; margin-top: 15px; text-align: center;">
          {{ "common.policies.clic" | translate
          }}<a href="https://www.vyootrip.com/aviso-legal/" target="_blank">{{
            "common.policies.terms-of-use" | translate
            }}</a>{{ "common.policies.confirm" | translate
          }}<a href="https://www.vyootrip.com/politica-de-cookies/" target="_blank">{{ "common.policies.cookie-policy"
            | translate }}</a>
        </p>
      </div>
      <h6>
        {{
        (((trainsInfo?.userFilters.onlyTrainAuthorization && !trainsInfo?.isAdmin) || (!isFareWithinRange() &&
        !trainsInfo?.isAdmin))
        ? "flight.result-flight.confirm-auth"
        : "flight.result-flight.confirm-book")
        | translate }}
      </h6>
      <div class="button-container">
        <button id="cancel" matStepperPrevious>
          {{ "flight.detail-flight.cancel" | translate }}
        </button>
        <button id="confirm" (click)="
              ((trainsInfo?.userFilters.onlyTrainAuthorization && !trainsInfo?.isAdmin) || (!isFareWithinRange() && !trainsInfo?.isAdmin))
                ? requestAuthorization()
                : onReserve()
            ">
          {{ "flight.detail-flight.confirm" | translate }}
        </button>
      </div>
    </div>
  </div>
  <app-trains-summary [activePage]="'confirm'" [stepper]="stepper"></app-trains-summary>
</div>